import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {},
}));

export default useStyles;
